export const CALL_DURATION_SEC = 60;
export const RING_TIMEOUT_SEC = 45;
export const HANGUP_KEY = "KeyA";

export const JITSI_CALL_BASE_CONFIG = {
  width: "100%",
  height: "100%",
  lang: "es",
  userInfo: {
    email: "user@fusepong.com",
    displayName: "Usuario",
    role: "user",
  },
  configOverwrite: {
    disableDeepLinking: true,
    enableWelcomePage: false,
    startWithVideoMuted: false,
    startWithAudioMuted: false,
    prejoinPageEnabled: false,
  },
  interfaceConfigOverwrite: {
    TOOLBAR_BUTTONS: [],
    SHOW_JITSI_WATERMARK: false,
    SHOW_WATERMARK_FOR_GUESTS: false,
    SHOW_BRAND_WATERMARK: false,
    SHOW_CHROME_EXTENSION_BANNER: false,
    HIDE_INVITE_MORE_HEADER: true,
    MOBILE_APP_PROMO: false,
    HIDE_DEEP_LINKING_LOGO: true,
    filmStripOnly: false,
    SHOW_CONTACTLIST_AVATARS: false,
    DEFAULT_REMOTE_DISPLAY_NAME: "",
    DEFAULT_LOCAL_DISPLAY_NAME: "",
    SHOW_PROMOTIONAL_CLOSE_PAGE: false,
    SHOW_POWERED_BY: false,
    SHOW_PARTICIPANTS_TAB: false,
    SHOW_CHAT_HEADER: false,
    SHOW_FOOTER_ACTIONS: false,
    TOOLBAR_ALWAYS_VISIBLE: false,
    DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
    DISABLE_DOMINANT_SPEAKER_INDICATOR: true,
    DISABLE_FOCUS_INDICATOR: true,
    TILE_VIEW_MAX_COLUMNS: 1,
    DISABLE_RINGING: true,
  },
};
